import HomeTemplate from 'src/components/atomic/template/Service/Home'
import React, { ChangeEvent, FocusEvent, useRef, useState } from 'react'
import { RootState } from 'src/store/store'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'
import { useTranslation } from 'react-i18next'
import useHomeEventBus from 'src/hooks/useEventBus/useHomeEventBus'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { setTempLockMessage } from 'src/store/Reducer/socket/homePageSlice'
import { Cmdtypes } from 'src/constants/cmdtypes'

import { RequestDataBody } from 'src/types/websocket'
import { SocketSender } from 'src/api/socket'
import { getCountryCallingCode } from 'react-phone-number-input'
import { CountryCodeType } from 'src/types/phoneinput'
import useMouseDownElement from 'src/hooks/useMouseDownElement.hook'

export type HomeDataPropsType = {
  MsgTextAreaBlur: (e: FocusEvent) => void
  onMsgTextAreaFocus: (e: FocusEvent<HTMLElement>) => void
  onLockMsgTextAreaChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
  onDeviceRefreshBtnHandler: () => void
  onEmergencyContactSubmit: () => void
  onLockMsgSubmit: () => void
  refreshStatus: boolean
  onMsgTextAreaContentsDelete: () => void
}
const HomePage = () => {
  const { t } = useTranslation()
  const msgInputRef = useRef<HTMLTextAreaElement | null>(null)
  const dispatch = useAppDispatch()
  const [refreshStatus, setRefreshStatus] = useState<boolean>(true)
  const { className: targetClassName } = useMouseDownElement()
  const { TempValue, CountryCode, GPNumber, LockMsg } = useAppSelector(
    (state: RootState) => state.HomePage,
  )

  const { Connection } = useAppSelector((state: RootState) => state.connection)
  const MsgTextAreaBlur = (e: FocusEvent) => {
    const target = e.relatedTarget?.className || targetClassName || ""

    //blur 된곳이 Save 버튼이 아닐 때
    switch (true) {
      case !target?.includes('screen_msg') && TempValue.LockMsg === '':
        return dispatch(
          setTempLockMessage(
            `${t('HOME.LOCKMSG_DEFAULT_MSG', {
              defaultValue: 'This is a lost device. Please take calls from the device owner.',
            })}`,
          ),
        )
      case !target?.includes('screen_msg') && TempValue.LockMsg !== LockMsg:
        dispatch(
          setModalItems({
            type: 'alert',
            text: `${t('MODAL.HOME_SCREEN_ERROR', {
              defaultValue: 'Failed to update Lock Screen Message. Please retry and tap Save.',
            })}`,
            confirmFunc: () => {
              msgInputRef.current && msgInputRef.current.focus()
            },
          }),
        )
        break
      default:
        break
    }
  }

  const onEmergencyContactSubmit = () => {
    if (TempValue.CountryCode.num === CountryCode && TempValue.GPNumber === GPNumber) {
      dispatch(
        setModalItems({
          type: 'alert',
          text: `${t('MODAL.HOME_CONTACT_ERROR', {
            defaultValue:
              'Failed to update emergency contact. Please retry and tap Save to update emergency contact.',
          })}`,
        }),
      )
    } else {
      dispatch(
        SocketSender<RequestDataBody.PhoneNumber>(Cmdtypes.PHONE_NUMBER_UPDATE, {
          GPNumber: TempValue.GPNumber,
          CountryCode: getCountryCallingCode(TempValue?.CountryCode?.country as CountryCodeType),
          // CountryCode: TempValue.CountryCode?.num?.replace('+', '') as string,
        }),
      )
    }
    return
  }

  const onLockMsgSubmit = () => {
    if (TempValue.LockMsg !== LockMsg) {
      dispatch(
        SocketSender<RequestDataBody.LockMsg>(Cmdtypes.LOCK_MSG_UPDATE, {
          LockMsg:
            (TempValue.LockMsg as string) === ''
              ? t('HOME.LOCKMSG_DEFAULT_MSG', {
                  defaultValue: 'This is a lost device. Please take calls from the device owner.',
                })
              : (TempValue.LockMsg as string),
        }),
      )
    } else {
      dispatch(
        setModalItems({
          type: 'alert',
          text: `${t('MODAL.HOME_SCREEN_ERROR', {
            defaultValue: 'Failed to update Lock Screen Message. Please retry and tap Save.',
          })}`,
        }),
      )
    }
  }

  const onLockMsgTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > 200) {
      return
    } else dispatch(setTempLockMessage(e.target.value))
  }

  const onMsgTextAreaFocus = () => {
    TempValue.LockMsg ===
      `${t('HOME.LOCKMSG_DEFAULT_MSG', {
        defaultValue: 'This is a lost device. Please take calls from the device owner.',
      })}` && dispatch(setTempLockMessage(''))
  }

  const onMsgTextAreaContentsDelete = () => {
    Connection && dispatch(setTempLockMessage(''))
    msgInputRef.current && msgInputRef.current.focus()
  }

  //새로고침 버튼
  const onDeviceRefreshBtnHandler = () => {
    if (refreshStatus) {
      setRefreshStatus(false)
      dispatch(SocketSender(Cmdtypes.HOME_INFO))
      setTimeout(() => {
        setRefreshStatus(true)
      }, 10000)
    }
  }

  useHomeEventBus()

  const data: HomeDataPropsType = {
    onDeviceRefreshBtnHandler,
    onEmergencyContactSubmit,
    onLockMsgSubmit,
    onLockMsgTextAreaChange,
    onMsgTextAreaFocus,
    MsgTextAreaBlur,
    refreshStatus,
    onMsgTextAreaContentsDelete,
  }

  return <HomeTemplate data={data} ref={msgInputRef} />
}
export default HomePage
